import { render, staticRenderFns } from "./Aside.vue?vue&type=template&id=aba4ea24&scoped=true&"
import script from "./Aside.vue?vue&type=script&lang=ts&"
export * from "./Aside.vue?vue&type=script&lang=ts&"
import style0 from "./Aside.vue?vue&type=style&index=0&id=aba4ea24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba4ea24",
  null
  
)

export default component.exports